/**
 * @desc: 交易规则设置
 * @created: 2020/5/22
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'
import qs from 'qs';

// 交易规则设置条件查询
export const getListData = params => {
  return request.get('/risk/queryRisk', params)
}

// 获取操作人id
export const getCreateIdList = params => {
  return request.get('/risk/selectCreateUser', params)
}

// 获取风控内容列表
export const getBriefOption = params => {
  return request.get('/risk/riskRuleBrief', params)
}

// 新增风控规则
export const postCreateRules = data => {
  return request.post('/risk/saveRisk', qs.stringify(data))
}

// 获取单条风控项数据
export const getCurrentRisk = params => {
  return request.get('/risk/getRisk', params)
}

// 修改风控规则
export const postUpdateRules = data => {
  return request.post('/risk/updateRisk', qs.stringify(data))
}

// 获取风控轴值列表
export const getRiskRuleAxis = params => {
  return request.get('/risk/riskRuleAxis', params)
}

// 获取名单释放的下拉框值
export const getListBlackRelease = params => {
  return request.get('/risk/listBalckRelease', params)
}
